import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import { QsPreview } from '@/components'

const { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
const { WizBrowserExport, WizModal, } = component_tool;

const _getValue = (type, key) => {
  const values = {
    callScene: {
      1: '列表用户拨打',
      2: '问卷拨打'
    },
  }
  return values[type][key] || ''
}

class WizCallLog extends WizContainer {
  componentName = "WizCallLog";

  constructor(props) {
    super(props);
    let { entityType, entityId, parentEntityId, applySurveyId, entityTypeNew, entityTypeList } = props
    log.info('props', props);
    this.state = {
      entityType,
      entityId,
      parentEntityId,
      applySurveyId,
      entityTypeNew,
      entityTypeList,
      surveyVisible: false,
      survey: {},//问卷信息
    };
  }
  propsAndStateOnChange = {
    surveyInfo: this._surveyInfo.bind(this),
  }
  _surveyInfo(nextProps, nextState) {
    let { surveyInfo } = nextProps
    if (surveyInfo['success']) {
      nextState['survey'] = surveyInfo['data']
      nextState['surveyVisible'] = true
      return true;
    } else {
      wizNotice.error(surveyInfo['msg'] || '获取问卷信息失败，请稍后再试')
    }
    return false;
  }
  _handleFile(nextProps, nextState, key) {
    let { entityType } = nextProps
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '呼叫方',
        field: 'callingName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '联系时间',
        field: 'contactTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '联系人姓名',
        field: 'contactName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '联系人账号',
        field: 'contactUser',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '致电场景',
        hidden: entityType == 2 || entityType == 3 || entityType == 6 ? false : true,
        field: 'callScene',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '关联题目序号',
        hidden: entityType == 2 || entityType == 3 || entityType == 6 ? false : true,
        field: 'ltemNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '备注',
        field: 'remark',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
    ]
    if (o['success']) {
      let data = Object.assign([], o['data'])
      data.forEach((val, index) => {
        val['callScene'] = _getValue('callScene', val['callScene'])
        val['ltemNumber'] = val['ltemNumber'] == -1 ? '' : val['ltemNumber']
      })
      WizBrowserExport({
        title: '通话记录',
        sheetName: '通话记录',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '通话记录.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  lookQuesDetail = ({ entityId }) => {
    this.doAction({
      path: 'survey/findSurveyAnswerById',
      payload: {
        key: 'survey@surveyInfo',
        apiParams: { id: entityId }
      }
    })
  }

  _render() {
    const { entityType, entityId, parentEntityId, surveyVisible, survey, applySurveyId, entityTypeNew, entityTypeList } = this.state

    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig(this, entityType),
      apiDataFormat: {
        personInfoExport: this._handleFile,
      },
      entityType, entityId, parentEntityId, applySurveyId, entityTypeNew, entityTypeList
    });

    return (
      <React.Fragment>
        <WizReduxTemplate {..._reduxTemplateCofig} />
        <WizModal
          visible={surveyVisible}
          title='查看问卷'
          width={800}
          onCancel={() => { this.setState({ surveyVisible: false }) }}
          footer={null}
          forceRender
        >
          <QsPreview data={{ ...survey, preview: false }} />
        </WizModal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { survey } = state;

  const surveyInfo = modelUtils.getModelEntity(survey, 'survey@surveyInfo');

  return {
    surveyInfo,
  };
};

export default connect(mapStateToProps)(WizCallLog);
